import { RouteLocationNormalized } from 'vue-router';
import { permissionsStateLoaded, usePermissionsStore } from '~/plugins/permission';
import { GateRedirect, normalizeGateValue, resolveGate } from './gate';

class Permission implements Middleware {
    name(): string {
        return 'permission';
    }

    async run(to: RouteLocationNormalized): Promise<GateRedirect | undefined> {
        if (!to.meta?.permission) return;

        const permission = normalizeGateValue(to.meta.permission as string | string[], to);
        const permissions = usePermissionsStore();

        // TODO: the failure redirect should arguably be a 403 instead of a 404.
        return resolveGate(
            to,
            () => permissionsStateLoaded(permission),
            () => permissions.has(permission, to.meta.permissionAny === true),
        );
    }
}

export default new Permission();
